export const supabaseUrl = "https://wcwrjovyjkqowlnsjtnl.supabase.co";

/** This is the anon access key and is expected to be public knowledge */
export const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indjd3Jqb3Z5amtxb3dsbnNqdG5sIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTQ3ODI3NTAsImV4cCI6MjAxMDM1ODc1MH0.DXAFXyYR9umg-GygCHOvwG1xXQI9Fxom9lkooQJWJE4";

/** This token is scoped to Better Intersections domains. */
export const mapboxToken = "pk.eyJ1IjoiamFrZWMiLCJhIjoiY21hbjl6bTdoMHRheTJ4b2o2YnkxOXRmOCJ9.0QxP2Fgh_GfAK1FnFuCmaw"